import { FC, useEffect, useState } from 'react';
import { PlayerMeta, Team } from '../../../types';
import { CbParticipantTeamPickerLayout } from './CbParticipantTeamPickerLayout';
export interface CbParticipantTeamPickerContainerProps {
  typeOfSearch: string;
  teams: Team[];
  selectedParticipants: any[];
  hideButton?: boolean;
  showNotificationSettings?: boolean;
  customTeamTitle?: string;
  customTeamTitleColor?: string;
  saveselectedParticipants: (player: PlayerMeta[], teams: Team[], current: string) => void;
  handleSort: (list: any[]) => Team[];
  handlePrimarySelected?: (id: number, notificationsEnabled: boolean) => Promise<void> | undefined;
  maxHeight?: string;
}
export const CbParticipantTeamPickerContainer: FC<CbParticipantTeamPickerContainerProps> = ({
  typeOfSearch,
  handleSort,
  hideButton,
  showNotificationSettings,
  customTeamTitle,
  customTeamTitleColor,
  teams,
  selectedParticipants,
  saveselectedParticipants,
  handlePrimarySelected,
  maxHeight
}) => {
  const [teamsList, setTeamsList] = useState(teams);
  const [selectedTeamIds, setselectedTeamIds] = useState<number[]>([]);
  useEffect(() => {
    setTeamsList([]);
    setselectedTeamIds([]);
  }, [typeOfSearch]);

  // team participant functions
  useEffect(() => {
    if (typeOfSearch === 'team') {
      const selectedIds = selectedParticipants.map(team => team?.id);
      setTeamsList(teams?.filter(unsavedParticipant => !selectedIds.includes(unsavedParticipant?.id)));
    }
  }, [teams, selectedParticipants]);
  const handleAddTeam = (team: Team): void => {
    setTeamsList(teamsList.filter(unsavedTeam => unsavedTeam?.id !== team?.id));
    saveselectedParticipants([], handleSort([...selectedParticipants, team]), typeOfSearch);
    setselectedTeamIds([...selectedTeamIds, team?.id]);
  };
  const handleRemoveTeam = (index: number, id: number): void => {
    const removeSelected = [...selectedParticipants];
    removeSelected.splice(index, 1);
    saveselectedParticipants([], removeSelected, typeOfSearch);
    setselectedTeamIds(selectedTeamIds?.filter(unsavedTeamId => unsavedTeamId !== id));
    setTeamsList(teamsList.filter(unsavedTeam => unsavedTeam?.id !== id));
  };
  const handleAddAllTeams = (): void => {
    const allIds = teamsList.map(team => team?.id);
    setTeamsList([...selectedParticipants, ...teamsList]);
    setselectedTeamIds([...selectedTeamIds, ...allIds]);
    saveselectedParticipants([], handleSort([...selectedParticipants, ...teamsList]), 'team');
  };
  const handleClearAllTeams = (): void => {
    setTeamsList([]);
    setselectedTeamIds([]);
    saveselectedParticipants([], [], 'team');
  };
  return <>
        <CbParticipantTeamPickerLayout hideButton={hideButton} showNotificationSettings={showNotificationSettings} customTeamTitle={customTeamTitle} customTeamTitleColor={customTeamTitleColor} teams={teamsList} selectedTeams={selectedParticipants} selectedTeamIds={selectedTeamIds} handleAddTeam={handleAddTeam} handleRemoveTeam={handleRemoveTeam} handleAddAllTeams={handleAddAllTeams} handleClearAllTeams={handleClearAllTeams} handlePrimarySelected={handlePrimarySelected} maxHeight={maxHeight} data-sentry-element="CbParticipantTeamPickerLayout" data-sentry-source-file="CbParticipantTeamPickerContainer.tsx" />
      </>;
};